import styled from 'styled-components';

export const StyledPlayerLevel = styled.div`
  font-family: var(--font-family), Arial;
  width: 216px;
  margin: 0 16px;
  position: relative;

  @media (max-width: $tablet) {
    max-width: 606px;
  }

  .image {
    max-width: 100%;
  }

  .free-text {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44%;
    right: 13%;
    top: 52%;
    color: #fcdd5f;
    text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
    font-size: 30px;
    font-style: normal;
    font-weight: 900;
    line-height: 1;
  }

  .ends-in-section {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: flex-end;
    bottom: 11%;
    right: 13%;

    .text {
      color: #c6aafb;
      text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5),
        0px 1px 1px rgba(0, 0, 0, 0.25);
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;

export const StyledTimeLeftValue = styled.div<{ width: string }>`
  color: #fff;
  text-shadow: 0px 0px 3px rgba(255, 255, 255, 0.75),
    0px 0px 1px rgba(0, 0, 0, 0.5), 0px 1px 1px rgba(0, 0, 0, 0.25);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: ${({ width }) => width};
`;
